function RichText() {
	this.build();
}

RichText.prototype.build = function () {
	$('img.picto').each(function(index, elem) {
		$(elem).wrap("<div class='picto__container'></div>");
	});
};
